<template>
    <b-modal v-if="!loading" id="product_form" ref="product_form"
             @hidden="resetForm" no-close-on-backdrop
             modal-class="modal-right modal-dialog-scrollable">

        <template v-slot:modal-title>
            {{ !edit ? 'Add Product' : 'Edit Product' }}
        </template>

        <div class="d-flex flex-row mb-4">
            <span class="iconsminds-add mr-3 menu-icon-style"/>

            <p class="my-auto">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi
                dolores quod, repellendus similique sint.
            </p>
        </div>

        <b-form>
            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Code" class="has-float-label">
                        <template v-slot:label>
                            <span>Code <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.code" :class="{'border-danger': 'code' in errors}"
                                      @input="'code' in errors ? delete errors.code : ''"
                                      autocomplete="off" placeholder="Code"/>

                        <b-form-invalid-feedback :state="!'code' in errors"
                                                 v-text="'code' in errors ? errors.code[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Name" class="has-float-label">
                        <template v-slot:label>
                            <span>Name <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.name" :class="{'border-danger': 'name' in errors}"
                                      @input="'name' in errors ? delete errors.name : ''"
                                      autocomplete="off" placeholder="Name"/>

                        <b-form-invalid-feedback :state="!'name' in errors"
                                                 v-text="'name' in errors ? errors.name[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Brand" class="has-float-label">
                        <template v-slot:label>
                            <span>Brand <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateBrand" v-model="selected.brand" :options="brands"
                                  :border-danger="'brand_id' in errors"/>

                        <b-form-invalid-feedback :state="!'brand_id' in errors"
                                                 v-text="'brand_id' in errors ? errors.brand_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Category" class="has-float-label">
                        <template v-slot:label>
                            <span>Category <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateCategory" v-model="selected.category" :options="categories"
                                  :border-danger="'category_id' in errors"/>

                        <b-form-invalid-feedback :state="!'category_id' in errors"
                                                 v-text="'category_id' in errors ? errors.category_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Product Unit" class="has-float-label">
                        <template v-slot:label>
                            <span>Product Unit <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateProductUnit" v-model="selected.product_unit" :options="product_units"
                                  :border-danger="'product_unit_id' in errors"/>

                        <b-form-invalid-feedback :state="!'product_unit_id' in errors"
                                                 v-text="'product_unit_id' in errors ? errors.product_unit_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Usage Unit" class="has-float-label">
                        <template v-slot:label>
                            <span>Usage Unit <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateDefaultUsageUnit" v-model="selected.default_uasge_unit" :options="default_usage_units"
                                  :border-danger="'default_usage_unit_id' in errors"/>

                        <b-form-invalid-feedback :state="!'default_usage_unit_id' in errors"
                                                 v-text="'default_usage_unit_id' in errors ? errors.default_usage_unit_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="6">
                    <b-form-group label="Expire Date" class="has-float-label">
                        <template v-slot:label>
                            <span>Expire Date <sup><code>*</code></sup></span>
                        </template>

                        <v-date-picker
                            popover-visibility="focus" mode="single"
                            v-model="datepicker.expire_date"
                            @input="'expire_date' in errors ? delete errors.expire_date : ''"
                            :input-props="{ class:'form-control' + ('expire_date' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>

                        <b-form-invalid-feedback :state="!'expire_date' in errors"
                                                 v-text="'expire_date' in errors ? errors.expire_date[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="6">
                    <b-form-group label="Cost" class="has-float-label">
                        <template v-slot:label>
                            <span>Cost <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.product_cost" :class="{'border-danger': 'product_cost' in errors}"
                                      @input="'product_cost' in errors ? delete errors.product_cost : ''"
                                      autocomplete="off" placeholder="Cost"/>

                        <b-form-invalid-feedback :state="!'product_cost' in errors"
                                                 v-text="'product_cost' in errors ? errors.product_cost[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Alert Quantity" class="has-float-label">
                        <template v-slot:label>
                            <span>Alert Quantity <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.alert_quantity" :class="{'border-danger': 'alert_quantity' in errors}"
                                      @input="'alert_quntity' in errors ? delete errors.alert_quntity : ''"
                                      autocomplete="off" placeholder="Alert Quantity"/>

                        <b-form-invalid-feedback :state="!'alert_quntity' in errors"
                                                 v-text="'alert_quntity' in errors ? errors.alert_quntity[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Opening Stock" class="has-float-label">
                        <template v-slot:label>
                            <span>Opening Stock <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.opening_stock" :class="{'border-danger': 'opening_stock' in errors}"
                                      @input="'opening_stock' in errors ? delete errors.opening_stock : ''"
                                      autocomplete="off" placeholder="Opening Stock"/>

                        <b-form-invalid-feedback :state="!'opening_stock' in errors"
                                                 v-text="'opening_stock' in errors ? errors.opening_stock[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group class="mb-4">
                        <b-form-file v-model="image" placeholder="Choose a picture..."/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Description" class="has-float-label">
                        <template v-slot:label>
                            <span>Description <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.product_description" :class="{'border-danger': 'product_description' in errors}"
                                      @input="'product_description' in errors ? delete errors.product_description : ''"
                                      autocomplete="off" placeholder="Description"/>

                        <b-form-invalid-feedback :state="!'product_description' in errors"
                                                 v-text="'product_description' in errors ? errors.product_description[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>
        </b-form>
        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('product_form')" v-text="'Cancel'"/>

            <state-button v-if="!edit" variant="primary" :click="submitProduct">Submit</state-button>

            <state-button v-else variant="primary" :click="updateProduct">Update</state-button>
        </template>
    </b-modal>
</template>

<script>
    import { mapGetters } from 'vuex'
    import StateButton from "../../../../../components/Common/StateButton";

    export default {
        name: "ProductFormModal",

        components: {
            StateButton,
        },

        props: [
            'edit'
        ],

        data() {
            return{
                loading: true,
                image: null,
                selected: {
                    categories: [],
                    brands: [],
                    product_units: [],
                    default_usage_unit: [],
                },
                datepicker: {
                    expire_date: null,
                },
                default_usage_units: [
                    {label: 'Cartons', value: 'Cartons'},
                    {label: 'Pieces', value: 'Pieces'},
                    {label: 'Pounds', value: 'lb'},
                    {label: 'Kilograms', value: 'kg'},
                    {label: 'Grams', value: 'gm'},
                    {label: 'Boxes', value: 'Boxes'},
                    {label: 'Other', value: 'Other'},
                ],
            }
        },

        computed: {
            ...mapGetters({
                form: 'getProductForm',
                errors: 'getProductErrors',
                brands: 'getSelectBrands',
                categories: 'getSelectCategories',
                product_units: 'getSelectProductUnits'

            })
        },

        mounted() {
            this.getForm();
        },

        methods: {
            async getForm() {
                await this.$store.dispatch('fetchSelectBrands');

                return this.loading = false;
            },

            resetForm() {
                this.$store.commit('setProductForm');

                this.selected.product = [];
            },

            updateBrand(field) {
                if (field) {
                    this.form.brand_id = field.brand_id;
                } else {
                    this.form.brand_id = '';
                }
                'brand_id' in this.errors ? delete this.errors.brand_id : '';
            },

            updateCategory(field) {
                if (field) {
                    this.form.category_id = field.category_id;
                } else {
                    this.form.category_id = '';
                }
                'category_id' in this.errors ? delete this.errors.category_id : '';
            },

            updateProductUnit(field) {
                if (field) {
                    this.form.product_unit_id = field.product_unit_id;
                } else {
                    this.form.product_unit_id = '';
                }
                'product_unit_id' in this.errors ? delete this.errors.product_unit_id : '';
            },

            updateDefaultUsageUnit(field) {
                if (field) {
                    this.form.default_usage_unit_id = field.defaault_usage_unit_id;
                } else {
                    this.form.defaault_usage_unit_id = '';
                }
                'defaault_usage_unit_id' in this.errors ? delete this.errors.defaault_usage_unit_id : '';
            },

            hideModal(refname) {
                this.$refs[refname].hide();
            },

            submitProduct() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('submitProduct', this.form)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('updated');

                                this.resetForm();

                                this.$notify('success filled', 'Success!', 'Added new Product!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('product_form');
                            }, 2000);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            },

            updateProduct() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('updateProduct', this.form)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('updated');

                                this.resetForm();

                                this.$notify('success filled', 'Success!', 'Updated the product!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('product_form');
                            }, 2000);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            },
        }
    }
</script>

<style scoped>

</style>
